import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import OptionPopupView from "views/common/OptionPopupView";
import Utils from "models/helper/Utils";
import AudioRecorderHelper from "models/helper/AudioRecorderHelper";
import RecordingSettingsPageTemplate from 'text!../../../templates/recordingSettings/RecordingSettingsPageTemplate.html';
import ti18n from "i18n!nls/RecordingSettingsi18n";
import PersistentModels from "services/PersistentModels";
import RSVP from "rsvp";

const RecordingSettingsPopupView = OptionPopupView.extend({


    initialize: function(options) {
        const viewOptions = {};
        const contentView = {};
        const contentViewTemplate = _.template(RecordingSettingsPageTemplate);
        const templateParams = {};
        templateParams.ti18n = ti18n;
        templateParams.isVideoRecordingMode = options && options.recordingMediaType === "video";
        contentView.$el = $(contentViewTemplate(templateParams));
        viewOptions.contentView = contentView;
        viewOptions.addContentAfterEnhancement = false;
        viewOptions.contentPosition = "center";
        viewOptions.displayTitle = true;
        viewOptions.titleToDisplay = window.getI18n(ti18n,"RECORDING_SETTINGS");
        this._popupUniqueId = "RecordingSettingsPopupView";
        viewOptions.id = this._popupUniqueId;
        this._preferredAudioDeviceId = options && options.preferredAudioDeviceId ?options.preferredAudioDeviceId: null;
        this._preferredVideoDeviceId = options && options.preferredVideoDeviceId ?options.preferredVideoDeviceId: null;
        this._recordingMediaType = options && options.recordingMediaType === "video" ? "video" : "audio";
        //viewOptions.elementSource$el = $("#showRecordingSettingsButton");
        //viewOptions.showAsMenuIfInBrowser = true
        
        OptionPopupView.prototype.initialize.call(this, viewOptions);
        
    },


    _close : function(){
        this.$el.popup('close' );
    },


    _removeParanthesesFromDeviceLabel : function(deviceLabel){
        return deviceLabel.replace(/ *\([^)]*\) */g, ' ').trim();
    },

    _getDeviceLabelToDisplay: function(device, fallbackBaseLabel, index) {
        const label = device && device.label ? this._removeParanthesesFromDeviceLabel(device.label) : "";

        if (label) {
            return label;
        }

        return fallbackBaseLabel + " " + (index + 1);
    },

    onPopupClosed: function() {
       OptionPopupView.prototype.onPopupClosed.call(this);
       this.trigger("onPopupClosed");
   },

   _addArrowToSelectWidget: function() {
    const microphoneButton$El = this.$el.find("#microphoneFld-button");
    const cameraButton$El = this.$el.find("#cameraFld-button");

    if (microphoneButton$El.length && microphoneButton$El.find(".ion-chevron-down").length === 0) {
        microphoneButton$El.append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
    }

    if (cameraButton$El.length && cameraButton$El.find(".ion-chevron-down").length === 0) {
        cameraButton$El.append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
    }
},

_refreshSelectWidget : function(select$El){
    if(select$El && select$El.length && select$El.data("mobile-selectmenu")){
        select$El.selectmenu("refresh", true);
    }
},

_addAudioDevicesAvailableToView : function(){
    const microphoneFld$El =  this.$el.find("#microphoneFld");
    const microphoneFldLabel$El = this.$el.find("#microphoneFld-button > span");
    microphoneFld$El.empty();
    return AudioRecorderHelper.getInstance().getAudioDevicesAvailable().then((function(audioDevicesAvailable){
      if(audioDevicesAvailable){
        let optionSelected = false;
        for(let i =0; i < audioDevicesAvailable.length; i++ ){
            const audioDevice = audioDevicesAvailable[i];
            const deviceLabel = this._getDeviceLabelToDisplay(audioDevice, window.getI18n(ti18n,"MICROPHONE"), i);
            if(this._preferredAudioDeviceId == audioDevice.deviceId){
                microphoneFld$El.append("<option value='"+audioDevice.deviceId+"' selected='selected'>"+ deviceLabel+"</option>");
                microphoneFldLabel$El.html(deviceLabel);
                optionSelected = true;
            }else{
                microphoneFld$El.append("<option value='"+audioDevice.deviceId+"'>"+ deviceLabel+"</option>");
            }
        }
        if(!optionSelected){
            microphoneFld$El.append("<option value='' disabled selected hidden>"+ window.getI18n(ti18n,"NO_PREFERRED_MIC_SELECTED")+"</option>");
                microphoneFldLabel$El.html(window.getI18n(ti18n,"NO_PREFERRED_MIC_SELECTED"));
                optionSelected = true;
        }
    }
    this._refreshSelectWidget(microphoneFld$El);
}).bind(this)).catch((function(error) {
    console.error(error);
    window.alertErrorMessage(error);
}).bind(this));

},

_addVideoDevicesAvailableToView : function(options){
    const viewOptions = options || {};
    const shouldPromptForDevices = viewOptions.shouldPromptForDevices !== false;
    const cameraFld$El =  this.$el.find("#cameraFld");
    const cameraFldLabel$El = this.$el.find("#cameraFld-button > span");

    if(!cameraFld$El || cameraFld$El.length === 0){
        return RSVP.Promise.resolve();
    }

    cameraFld$El.empty();
    const videoDevicesPromise = shouldPromptForDevices ? AudioRecorderHelper.getInstance().getVideoDevicesAvailable() : AudioRecorderHelper.getInstance().getVideoDevicesAvailableWithoutPrompt();

    return videoDevicesPromise.then((function(videoDevicesAvailable){
        if(videoDevicesAvailable){
            let optionSelected = false;
            for(let i =0; i < videoDevicesAvailable.length; i++ ){
                const videoDevice = videoDevicesAvailable[i];
                const deviceLabel = this._getDeviceLabelToDisplay(videoDevice, window.getI18n(ti18n,"CAMERA"), i);
                if(this._preferredVideoDeviceId == videoDevice.deviceId){
                    cameraFld$El.append("<option value='"+videoDevice.deviceId+"' selected='selected'>"+ deviceLabel+"</option>");
                    cameraFldLabel$El.html(deviceLabel);
                    optionSelected = true;
                }else{
                    cameraFld$El.append("<option value='"+videoDevice.deviceId+"'>"+ deviceLabel+"</option>");
                }
            }
            if(!optionSelected){
                cameraFld$El.append("<option value='' disabled selected hidden>"+ window.getI18n(ti18n,"NO_PREFERRED_CAMERA_SELECTED")+"</option>");
                cameraFldLabel$El.html(window.getI18n(ti18n,"NO_PREFERRED_CAMERA_SELECTED"));
            }
        }
        this._refreshSelectWidget(cameraFld$El);
    }).bind(this)).catch((function(error) {
        console.error(error);
        window.alertErrorMessage(error);
    }).bind(this));

},


getAudioDeviceIdSelected: function() {
    return this.$el.find("#microphoneFld option:selected").val();
},

getVideoDeviceIdSelected: function() {
    return this.$el.find("#cameraFld option:selected").val();
},

isVideoRecordingMode: function() {
    return this._recordingMediaType === "video";
},


_onPreferredAudioDeviceChanged : function(){
    const deviceId = this.getAudioDeviceIdSelected();
    this.trigger("audioDeviceChanged",deviceId);
},

_loadAvailableDevicesIntoView: function() {
    return this._addAudioDevicesAvailableToView().then((function() {
        if (!this.isVideoRecordingMode()) {
            return null;
        }

        return AudioRecorderHelper.getInstance().getPermissionToRecord("video").then((function() {
            return this._addVideoDevicesAvailableToView();
        }).bind(this)).catch((function(error) {
            console.error(error);
            return this._addVideoDevicesAvailableToView({ shouldPromptForDevices: false });
        }).bind(this));
    }).bind(this));
},

afterRendering: function() {
   const saveBtn$el = this.$el.find("#saveBtn");
   this.microphoneFld$el = this.$el.find("#microphoneFld");
   this.cameraFld$el = this.$el.find("#cameraFld");
   this._loadAvailableDevicesIntoView().catch((function(error) {
    console.error(error);
    window.alertErrorMessage(error);
   }).bind(this)).then((function(){
    this._addArrowToSelectWidget();
   }).bind(this));
   this.microphoneFld$el.on("change", this._onPreferredAudioDeviceChanged.bind(this));

   saveBtn$el.on("click", (function(){
    this.trigger("saveChanges");
}).bind(this));


},



});

export default RecordingSettingsPopupView;
